// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.room-settings-modal {
  display: flex;
  flex-direction: column;
  background-color: white;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.room-settings-modal * {
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.room-settings-modal-header {
  flex-shrink: 0;
  border-bottom: 4px solid #DE4858;
}

.room-settings-modal-body {
  flex: 1;
  display: flex;
  overflow: hidden;
  min-height: 0;
}

.room-settings-modal-content {
  flex: 1;
  overflow-y: auto;
  background-color: white;
  min-height: 0;
  padding: 42px 29px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/RoomSettings/Modal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gGAAgG;AAClG;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB","sourcesContent":[".room-settings-modal {\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.room-settings-modal * {\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.room-settings-modal-header {\n  flex-shrink: 0;\n  border-bottom: 4px solid #DE4858;\n}\n\n.room-settings-modal-body {\n  flex: 1;\n  display: flex;\n  overflow: hidden;\n  min-height: 0;\n}\n\n.room-settings-modal-content {\n  flex: 1;\n  overflow-y: auto;\n  background-color: white;\n  min-height: 0;\n  padding: 42px 29px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
